<template>
    <div class="grid mr-2" v-if="notice">
        <div class="col-12 important-notice ml-2" style="background-color:white">
            <div>
                <h5 style="font-weight:bold;color:red;font-size:1.2em"><i class="pi pi-info-circle"></i> Important Notice!</h5>
                <div style="font-size:1.1em" v-html="notice">
                    
                </div>
            </div>
        </div>
    </div>
    <div class="grid" v-if="showDashboard"> 
        <div class="col-3">
            <div class="card mb-2" v-if="showSAPOrder">
                <div class="flex justify-content-between">
                    <div>
                        <span class="block text-500 font-medium">Total SAP Orders</span>
                        <div class="text-900 font-medium text-xl">{{sapOrderTotal}}</div>
                    </div>
                    <div class="flex align-items-center justify-content-center bg-blue-100 border-round" style="width:2.5rem;height:2.5rem">
                        <i class="pi pi-shopping-cart text-blue-500 text-xl"></i>
                    </div>
                    
                </div>
                <!-- <div class="flex justify-content-between mt-3">
                    <span class="block text-500 font-medium">Waiting for Approval</span>
                    <div class="text-900 font-medium text-xl">{{sapOrderWaitingApproval}}</div>
                </div>
                <div class="flex justify-content-between mt-3">
                    <span class="block text-500 font-medium">Approved</span>
                    <div class="text-900 font-medium text-xl">{{sapOrderApproved}}</div>
                </div> -->
            </div>
             <div class="card mb-2" v-if="showOrder">
                <div class="flex justify-content-between">
                    <div>
                        <span class="block text-500 font-medium">Total Orders</span>
                        <div class="text-900 font-medium text-xl">{{orderTotal}}</div>
                    </div>
                    <div class="flex align-items-center justify-content-center bg-teal-100 border-round" style="width:2.5rem;height:2.5rem">
                        <i class="pi pi-inbox text-teal-500 text-xl"></i>
                    </div>
                </div>
                 <div class="flex justify-content-between mt-3">
                    <span class="block text-500 font-medium">Waiting for Approval</span>
                    <div class="text-900 font-medium text-xl">{{orderWaitingApproval}}</div>
                </div>
                 <div class="flex justify-content-between mt-3">
                    <span class="block text-500 font-medium">Assigned to Transporter</span>
                    <div class="text-900 font-medium text-xl">{{orderAssigned}}</div>
                </div>
                 <!-- <div class="flex justify-content-between mt-3">
                    <span class="block text-500 font-medium">Cancelled</span>
                    <div class="text-900 font-medium text-xl">{{orderCancelled}}</div>
                </div>
                <div class="flex justify-content-between mt-3">
                    <span class="block text-500 font-medium">Rejected</span>
                    <div class="text-900 font-medium text-xl">{{orderRejected}}</div>
                </div> -->
                <div class="flex justify-content-between mt-3">
                    <span class="block text-500 font-medium">Completed</span>
                    <div class="text-900 font-medium text-xl">{{orderCompleted}}</div>
                </div>
            </div>
             <div class="card mb-2" v-if="showShipment">
                <div class="flex justify-content-between">
                    <div>
                        <span class="block text-500 font-medium">Total Shipments</span>
                        <div class="text-900 font-medium text-xl">{{shipmentTotal}}</div>
                    </div>
                    <div class="flex align-items-center justify-content-center bg-indigo-100 border-round" style="width:2.5rem;height:2.5rem">
                        <i class="pi pi-car text-indigo-500 text-xl"></i>
                    </div>
                </div>
                 <div class="flex justify-content-between mt-3">
                    <span class="block text-500 font-medium">New</span>
                    <div class="text-900 font-medium text-xl">{{shipmentNew}}</div>
                </div>
                 <div class="flex justify-content-between mt-3">
                    <span class="block text-500 font-medium">Appointment Created</span>
                    <div class="text-900 font-medium text-xl">{{shipmentAppointment}}</div>
                </div>
                 <div class="flex justify-content-between mt-3">
                    <span class="block text-500 font-medium">Registration In</span>
                    <div class="text-900 font-medium text-xl">{{shipmentRegisIn}}</div>
                </div>
                 <div class="flex justify-content-between mt-3">
                    <span class="block text-500 font-medium">Registration Out</span>
                    <div class="text-900 font-medium text-xl">{{shipmentRegisOut}}</div>
                </div>
                 <div class="flex justify-content-between mt-3">
                    <span class="block text-500 font-medium">Completed</span>
                    <div class="text-900 font-medium text-xl">{{shipmentCompleted}}</div>
                </div>
            </div>
        </div>
        <div class="col-9">
            <div class="card">
                <h5>Total orders completed last 7 days</h5>
                <Chart type="bar" :data="completedData" :options="basicOptions" height="100"/>
            </div>
        </div>
        
    </div>
</template>

<script>
    export default {
        name: 'Home',
        props: {
            msg: String
        },
        data(){
            return{
                sapOrderTotal: 0,
                sapOrderWaitingApproval: 0,
                sapOrderApproved: 0,

                orderTotal: 0,
                orderWaitingApproval: 0,
                orderCancelled: 0,
                orderRejected: 0,
                orderAssigned: 0,
                orderCompleted: 0,

                shipmentTotal: 0,
                shipmentNew: 0,
                shipmentAppointment: 0,
                shipmentRegisIn: 0,
                shipmentRegisOut: 0,
                shipmentCompleted: 0,

                completedData: null,
                dataUrl: "dashboard/",

                // basicData: {
                //     labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                //     datasets: [
                //         {
                //             label: 'My First dataset',
                //             backgroundColor: '#42A5F5',
                //             data: [65, 59, 80, 81, 56, 55, 40]
                //         },
                //         {
                //             label: 'My Second dataset',
                //             backgroundColor: '#FFA726',
                //             data: [28, 48, 40, 19, 86, 27, 90]
                //         }
                //     ]
                // },
                basicOptions: {
                    plugins: {
                        legend: {
                            labels: {
                                color: '#495057'
                            }
                        }
                    },
                    scales: {
                        x: {
                            ticks: {
                                color: '#495057'
                            },
                            grid: {
                                color: '#ebedef'
                            }
                        },
                        y: {
                            ticks: {
                                color: '#495057'
                            },
                            grid: {
                                color: '#ebedef'
                            }
                        }
                    }
                },
                noticeUrl : "util/important_notice",
                notice: "",
            }
        },
        methods:{
            showToast(){
                this.$toast.add({ severity: 'error', summary: "Error", detail: "data", life: 120000});
            },
            getDataCompletedChart(){
                var self = this;

                this.$axios.get(this.$API_URL + this.dataUrl + "completed")
                    .then((response) => {
                        if(response && response.data.success){
                            self.completedData = response.data.data;
                        }
                    })
                    .catch(function (err) {
                        console.log(err);
                    });
            },
            getStatusCount(){
                var self = this;

                this.$axios.get(this.$API_URL + this.dataUrl + "status_count")
                    .then((response) => {
                        if(response && response.data.success){
                            var d = response.data.data;
                            self.sapOrderTotal = d.sap_order_total;
                            self.sapOrderWaitingApproval = d.sap_order_waiting_approval;
                            self.sapOrderApproved = d.sap_order_approved;
                            self.orderTotal = d.order_total;
                            self.orderWaitingApproval = d.order_waiting_approval;
                            self.orderAssigned = d.order_assigned;
                            self.orderCancelled = d.order_cancelled;
                            self.orderRejected = d.order_rejected;
                            self.orderCompleted = d.order_completed;
                            self.shipmentTotal = d.shipment_total;
                            self.shipmentNew = d.shipment_new;
                            self.shipmentAppointment = d.shipment_appointment;
                            self.shipmentRegisIn = d.shipment_regis_in;
                            self.shipmentRegisOut = d.shipment_regis_out;
                            self.shipmentCompleted = d.shipment_completed;

                        }
                    })
                    .catch(function(err){
                        console.log(err);
                    });
            },
            getImportantNotice(){
                var self = this;

                this.$axios.get(this.$API_URL + this.noticeUrl)
                    .then((response) => {
                        if(response.data.success){
                            self.notice = response.data.data;
                        }
                    })
                    .catch(function(err){
                        console.log(err);
                    });
            }
        },
        mounted(){
            if(!this.$store.getters.isAuthenticated){
                this.$router.push({ name: "Login", params: { sessionExpired: true} });
            }

            this.getDataCompletedChart();
            this.getStatusCount();
            this.getImportantNotice();
        },
        computed:{
            showDashboard(){
                return this.$store.getters.getIsUser;
            },
            showOrder(){
                return this.$store.getters.getIsAdmin || (this.$store.getters.getIsUser && this.$store.getters.getDepartment != this.$DEPARTMENTS.WAREHOUSE);
            },
            showSAPOrder(){
                return this.$store.getters.getIsAdmin || (this.$store.getters.getIsUser && this.$store.getters.getDepartment != this.$DEPARTMENTS.WAREHOUSE);
            },
            showShipment(){
                return this.$store.getters.getIsUser;
            }
        }
    }

    //  var values = [],
    //     keys = Object.keys(localStorage),
    //     i = keys.length;

    // while ( i-- ) {
    //     values.push( localStorage.getItem(keys[i]) );
    // }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .important-notice{
        border:2px dashed red;
    }
</style>
